import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';


export const MasterProviderFormValidations = {
    id: [{ type: 'required', message: 'ID is required' }],

    name: [{ type: 'required', message: 'Provider name is required' }],
    user: [{ type: 'required', message: 'User is required' }],
    code: [{ type: 'required', message: 'Code is required' }],

    password: [
        { type: 'required', message: 'Password is required' },
        { type: 'minlength', value: 6, message: 'Password must be at least 6 characters' },
        { 
            type: 'pattern', 
            value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{6,}$/, 
            message: 'Password must contain at least one uppercase, one lowercase, and one number' 
        }
    ],

    secret_code: [{ type: 'required', message: 'Secret code is required' }],

    base_url: [
        { type: 'required', message: 'Base URL is required' },
        { type: 'pattern', value: /^(https?:\/\/)?([\w-]+(\.[\w-]+)+)(\/[\w-]*)*$/, message: 'Enter a valid URL' }
    ],

    method: [{ type: 'required', message: 'Method is required' }],

    inq_param: [{ type: 'required', message: 'Inquiry parameter is required' }],
    pay_param: [{ type: 'required', message: 'Payment parameter is required' }],
    adv_param: [{ type: 'required', message: 'Advice parameter is required' }],
    reversal_param: [{ type: 'required', message: 'Reversal parameter is required' }],

    inq_url: [
        { type: 'required', message: 'Inquiry URL is required' },
        { type: 'pattern', value: /^(https?:\/\/)?([\w-]+(\.[\w-]+)+)(\/[\w-]*)*$/, message: 'Enter a valid URL' }
    ],

    pay_url: [
        { type: 'required', message: 'Payment URL is required' },
        { type: 'pattern', value: /^(https?:\/\/)?([\w-]+(\.[\w-]+)+)(\/[\w-]*)*$/, message: 'Enter a valid URL' }
    ],

    adv_url: [
        { type: 'required', message: 'Advice URL is required' },
        { type: 'pattern', value: /^(https?:\/\/)?([\w-]+(\.[\w-]+)+)(\/[\w-]*)*$/, message: 'Enter a valid URL' }
    ],

    reversal_url: [
        { type: 'required', message: 'Reversal URL is required' },
        { type: 'pattern', value: /^(https?:\/\/)?([\w-]+(\.[\w-]+)+)(\/[\w-]*)*$/, message: 'Enter a valid URL' }
    ]
    ,callback_url: [
        { type: 'pattern', value: /^(https?:\/\/)?([\w-]+(\.[\w-]+)+)(\/[\w-]*)*$/, message: 'Enter a valid URL' }
    ]

};

